import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/context/AuthContext';

const getPageTitle = (pathname) => {
  if (pathname === '/user') return 'Dashboard';
  if (pathname.includes('/products/create')) return 'Add Product';
  if (pathname.includes('/products/') && pathname.endsWith('/edit')) {
    return 'Edit Product';
  }
  if (pathname.startsWith('/user/products')) return 'Products';
  if (pathname.startsWith('/user/batches')) return 'Batches';
  if (pathname.startsWith('/user/invoices')) return 'Invoices';
  if (pathname.startsWith('/user/stock')) return 'Stock';
  return 'Distributor Portal';
};

const UserHeader = ({ onMenuClick }) => {
  const { user, currentUser } = useAuth();
  const location = useLocation();

  const profile = user || currentUser || {};
  const displayName =
    profile.name ||
    profile.username ||
    'Distributor';

  const firmId = profile.firm_id ?? profile.firmId ?? '—';
  const pageTitle = getPageTitle(location.pathname);

  const initials = displayName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');

  return (
    <header className="user-header">
      <div className="user-header-left">
        <button
          type="button"
          className="user-menu-toggle"
          aria-label="Open navigation menu"
          onClick={onMenuClick}
        >
          <span />
          <span />
          <span />
        </button>

        <div>
          <div className="user-header-eyebrow">YOUR WORKSPACE</div>
          <h1>{pageTitle}</h1>
        </div>
      </div>

      <div className="user-header-profile">
        <div className="user-header-profile-info">
          <strong>{displayName}</strong>
          <span>Firm ID: {firmId}</span>
        </div>

        <div className="user-avatar" aria-label={displayName}>
          {initials || 'U'}
        </div>
      </div>
    </header>
  );
};

export default UserHeader;